<template>
    <div v-if="checklist && canView" ref="container" id="detail-content" class="content scrollbar right" :class="$mq">
        <div class="top-container" :class="{ infoOpened: infoIsOpen }">
            <AppccTopDetail :hasMoreOptions="true" @deleteButton="deleteIssue()" @infoOpened="infoOpened" @backButton="back()" @settingsButton="settingsRegister" :userInfo="checklist.employee" :title="cTitle != '' ? cTitle : checklist.title" :issue="checklist" :hasDelete="true" :hasReopen="false" />
        </div>

        <!-- SECTIONS NAV BAR -->
        <div class="sections-navbar" v-if="hasSections" v-show="shouldShowSectionsNavbar">
            <TemplateSections :sections="sections" :doneSectionsIds="doneSectionsIds" :firstNotDoneSectionId="firstNotDoneSectionId" />
        </div>

        <!-- PROGRESS BAR -->
        <div class="progress-bar-section">
            <ProgressBar v-if="checklist" :itemsCompleted="checklist.completed || 0" :itemsTotal="checklist.total || 0" />
        </div>

        <!-- SEARCH BAR  -->
        <div class="search-bar-container" v-if="showSearchBar" v-show="shouldShowSearchBar">
            <SearchBar :search="searchValue" @on-search="handleSearch" @on-button-click="handleClearSearch" :placeholder="$t('detail.sections_search.placeholder')" />
        </div>

        <!-- INCIDENT STATUS -->
        <div class="resume" v-show="!isPopupOpen">
            <div class="change-state"></div>
            <!-- <div class="select" v-if="Object.values(issueStates).length > 0">
                <div class="ball" :style="{ backgroundColor: issueStates[checklist.status].color }"></div>
                <select v-if="issueStates" class="state-selected" :class="'status-' + checklist.status" @change="changeState" @click="disableSelector">
                    <option v-for="(state, index) in sortedIssueStates" :key="index" :value="state.id" :selected="checklist.status == state.id">
                        <div class="state-name">{{ state.name }}</div>
                    </option>
                </select>
            </div> -->
            <div class="state-container" ref="stateSelector" :class="{ isOpen: isSelectorOpen }" @click="isSelectorOpen = !isSelectorOpen">
                <div class="current-state" v-if="Object.values(issueStates).length > 0" :class="{ isOpen: isSelectorOpen }">
                    <div class="ball" v-if="issueStates[checklist.status].color" :style="{ backgroundColor: issueStates[checklist.status].color }"></div>
                    <div class="name">
                        {{ issueStates[checklist.status].name }}
                    </div>
                </div>
                <div class="state-selector" v-if="isSelectorOpen" :class="{ active: isSelectorOpen }">
                    <div class="state" v-for="(state, index) in sortedIssueStates" @click="changeState(state.id)" :key="index" :class="{ selected: checklist.status == state.id }">
                        <div class="ball" :style="{ backgroundColor: state.color }"></div>
                        <div class="name">
                            {{ state.name }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- DETAIL BOX (sections and items)-->
        <div class="detail-box" :class="[{ 'with-sections': hasSections }, { 'opened-info': infoIsOpen }, { 'with-search-bar': showSearchBar }]">
            <div v-if="collapsedInfo" class="list-info" :class="{ 'with-sections': hasSections }">
                <span class="action delete" @click="deleteIssue()">{{ $t('issues.actions.delete') }}</span>
            </div>

            <div class="exam performing hide-scrollbar" id="exam" :class="[{ 'hide-scrollbar': ['portrait'].includes($mq) }, { scrollbar: ['landscape', 'desktop'].includes($mq) }]">
                <SimpleToast v-if="checklist.description" :key="checklist.id" :text="checklist.description" :includeToggleButton="true" type="checklist-description" :parse="true" />

                <div class="note-detail">
                    <NoteDetail v-if="notes && notes.length > 0" :notes="notes" />
                </div>

                <div v-if="checklist.recover && editable && !checklist.complete_date" class="get-last-values">
                    <span class="message" @click="recoverValues()">{{ $t('tasks.get_last_values') }}</span>
                </div>

                <template v-if="checklist.data && checklist.data.ref && loadRef">
                    <div class="message-container">
                        <Message :message="getStringVariables('answer.reference.task', refTask)" :buttonLabel="getString('answer.reference.task_action')" @buttonAction="goToReference" type="info"></Message>
                    </div>
                    <!-- <div v-else class="reference-link" @click="goToReference">
                        <div class="alex"></div>
                        <div class="message keep-format" @click="goToReference" v-html="getStringVariables('answer.reference.task', refTask)"></div>
                        <div class="read-more">
                            {{ getString('answer.reference.task_action') }}
                        </div>
                    </div> -->
                </template>
                <template v-if="sensorObject">
                    <div class="message-container">
                        <Message
                            :message="
                                getStringVariables(sensorIssueGeneratedBySensorKey, {
                                    sensor: sensorObject ? sensorObject.name : '',
                                    value: sensorIssueReading,
                                    date: formatDate(checklist.data.ref.date)
                                })
                            "
                            :buttonLabel="getString('answer.reference.task_action')"
                            @buttonAction="goToSensor"
                            type="info"
                        ></Message>
                    </div>
                </template>

                <template v-if="checklist && checklist.items && Object.values(issueStates).length > 0">
                    <template v-if="showNoResultsEmptyState">
                        <EmptyPage :description="searchNoResultsMessage" />
                    </template>
                    <template v-else>
                        <!-- ITEMS -->
                        <Answer v-for="(answer, index) in checklistItems" :key="index" @section-toggled="(sectionId, isOpen) => handleShowOrHideSectionItems(sectionId, isOpen)" :class="{ hidden: closedSectionsIds.includes(answer.section_id) }" :doneSectionsIds="doneSectionsIds" @acTitle="updateTitle" :isIssueClosed="issueStates[checklist.status].type == 3" :item="answer" :list="checklist" :cId="checklist.id" :aId="answer.item_id" @checkAllMandatory="checkAllMandatory" :cType="type" :showErrors="showErrors" />
                    </template>
                    <div class="close-issue" v-if="allMandatory && Object.values(issueStates).length > 0">
                        <div class="text">
                            {{ $t('issue.want_close') }}
                        </div>
                        <div class="state-card" @click="changeState(getIssueStateClose().id)">
                            <div class="ball" :style="{ backgroundColor: getIssueStateClose().color }"></div>
                            <div class="state-name">{{ $t('issues.close_issue') }}</div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
    <div v-else class="content hide-scrollbar right empty">
        <!-- <div class="message empty">
            {{ getString('issues.empty') }}
        </div> -->
        <EmptyPage :buttonText="$t('empty_pages.return_issues')" @buttonAction="back()" buttonClass="back" :type="'error'" :title="$t('assets.overlay.timeout.message')" :description="$t('empty_pages.error_issues')"> </EmptyPage>
    </div>
</template>

<script>
import { formatTemperature, formatDecimal } from '@/utils/numberFormat'
import EmptyPage from '../../layout/EmptyPage.vue'
import SimpleToast from '@/components/layout/SimpleToast.vue'
import { FORMAT } from '@/constants'
import Answer from '@/components/domain/tasks/answer'
import AppccTopDetail from '@/components/layout/AppccTopDetail'
import UserTag from '@/components/layout/UserTag'
import Message from '@/components/domain/ui/Message'
import TemplateSections from '@/components/layout/TemplateSections'
import NoteDetail from '@/components/layout/NoteDetail'
import ProgressBar from '@/components/domain/ui/ProgressBar'
import SearchBar from '@/components/domain/ui/SearchBar'
import { formatDisplayDateFromStore, formatDisplayDateOnlyFromStore } from '@/utils/dateFormatters'
import { isHumiditySensor } from '@/utils/sensorStatus'

export default {
    components: { Answer, UserTag, EmptyPage, AppccTopDetail, Message, TemplateSections, NoteDetail, ProgressBar, SearchBar, SimpleToast },
    props: {
        gId: { type: String },
        askTitle: { type: Boolean, default: false },
        permissions: { type: Boolean, default: false },
        canView: { type: Boolean, default: true }
    },
    data() {
        return {
            isSelectorOpen: false,
            collapsedInfo: false,
            type: 4,
            refTask: {},
            FORMAT: FORMAT,
            loadRef: false,
            infoIsOpen: false,
            stateSelected: false,
            allMandatory: false,
            stateChanged: false,
            issueGeneratedBySensor: false,
            sensor: false,
            showErrors: false,
            showNonApply: true,
            cTitle: '',
            closedSectionsIds: [],
            searchValue: ''
        }
    },
    computed: {
        isPopupOpen() {
            return this.$store.state.selectPopup === true
        },
        done() {
            return parseInt((this.checklist.completed / this.checklist.total) * 100)
        },
        checklist() {
            let result = this.$store.getters['issues/getById'](this.gId)
            if (!this.refCheck || this.refCheck == '') {
                this.loadReference(result)
            }
            if (result && result.data && result.data.ref && result.data.ref.sensor) {
                this.issueGeneratedBySensor = true
                this.sensor = result.data.ref.sensor
            }
            // Esconder botones en caso de que aparezca el error
            if (result == undefined) {
                this.$bar.hide()
            }
            return result
        },
        checklistItems() {
            return this.hasSections && this.searchValue.length > 0 && this.searchResult.length > 0 ? this.searchResult : Object.values(this.checklist.items)
        },
        sensorObject() {
            if (this.checklist && this.checklist.data && this.checklist.data.ref && this.checklist.data.ref.sensor) return this.$store.getters['sensor/getList'](this.checklist.data.ref.sensor)
            else return false
        },
        sensorIssueReading() {
            const value = this.checklist.data.ref.value
            return isHumiditySensor(this.sensorObject) ? formatDecimal(value, this.$i18n.locale) : formatTemperature(value, this.$i18n.locale)
        },
        sensorIssueGeneratedBySensorKey() {
            return isHumiditySensor(this.sensorObject) ? 'answer.issue_generated_by_sensor_humidity' : 'answer.issue_generated_by_sensor'
        },
        sections() {
            const sections = []

            if (this.checklist && this.checklist.items) {
                for (var i in this.checklist.items) {
                    if (this.checklist.def.item.itemsTitle.indexOf(this.checklist.items[i].type) != -1) {
                        sections.push(this.checklist.items[i])
                    }
                }
            }

            return sections
        },
        hasSections() {
            return this.sections && this.sections.length > 1
        },
        shouldShowSectionsNavbar() {
            const isMobile = this.$mq === 'portrait'
            const isUserTyping = this.$store.getters['tasks/isUserTyping']
            // No mostrar sections navbar mientras es móvil y el usuario escribe en un input de texto
            if (isMobile && isUserTyping) return false
            return this.hasSections
        },
        showSearchBar() {
            return this.hasSections && this.sections.length > 5
        },
        shouldShowSearchBar() {
            const isMobile = this.$mq === 'portrait'
            const isUserTyping = this.$store.getters['tasks/isUserTyping']
            // No mostrar search bar mientras es móvil y el usuario escribe en un input de texto
            if (isMobile && isUserTyping) return false
            return this.showSearchBar
        },
        issueStates() {
            return this.$store.getters['getIssueStates']
        },
        sortedIssueStates() {
            let states = this.$store.getters['getIssueStates']
            let sortedStates = states ? Object.values(states).sort((states1, states2) => (states1.type > states2.type ? 1 : states1.name < states2.name ? -1 : 1)) : []
            return sortedStates
        },
        loggedUser() {
            return this.$store.getters['loginUser/getLocalEmployee']
        },
        user() {
            if (this.loggedUser) {
                return this.$store.getters['employee/getEmployee'](this.loggedUser)
            }
            return false
        },
        itemsExcluded() {
            return this.$store.getters['tasks/getItemsExcluded']
        },
        roles() {
            return this.$store.getters['employee/getAllRoles']
        },
        roleUserLogged() {
            var user = this.$store.getters['loginUser/getLocalEmployee']
            var roleUserLogged = this.$store.getters['employee/getEmployee'](user)
            var levelRoleUserLogged = this.$store.getters['employee/getRol'](roleUserLogged.rol)
            return levelRoleUserLogged
        },
        notes() {
            return this.$store.getters['issues/getNotesById'](this.gId)
        },
        doneSectionsIds() {
            if (!this.checklist.sections) {
                return []
            }

            let doneSectionsIds = []

            const checklistSections = Object.values(this.checklist.sections)

            for (const section of checklistSections) {
                const sectionItemsAndSubitems = Object.values(this.checklist.items).filter((item) => item.section_id === section.section_id)

                const onlyItemsAndVisibleSubitems = sectionItemsAndSubitems.filter((item) => !item.parent_id || (item.parent_id && item.is_visible))

                if (onlyItemsAndVisibleSubitems.every((item) => this.isItemCompleted(item))) {
                    doneSectionsIds.push(section.section_id)
                }
            }

            return doneSectionsIds
        },
        firstNotDoneSectionId() {
            if (!this.checklist.sections || !this.doneSectionsIds) {
                return null
            }

            const allSectionsIds = Object.keys(this.checklist.sections)

            return allSectionsIds.find((sectionId) => !this.doneSectionsIds.includes(sectionId))
        },
        showNoResultsEmptyState() {
            return this.hasSections && this.searchValue.length > 0 && this.searchResult.length === 0
        },
        searchNoResultsMessage() {
            return this.$t('empty_pages.sections_not_found', { searchInput: this.searchValue })
        }
    },
    methods: {
        /**
         * Determina si un item del checklist está completado.
         * Los items tipo LINK y RESOURCE se consideran siempre completados porque no guardan un valor.
         * @param {Object} item - El item del checklist a evaluar
         * @returns {boolean} - true si el item está completado, false en caso contrario
         */
        isItemCompleted(item) {
            return (item.value !== null && item.value !== '') || item.apply == 0 || item.type === FORMAT.LINK || item.type === FORMAT.RESOURCE
        },
        normalizeText(text) {
            if (!text) return ''

            return text
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '') // Remover diacríticos (tildes)
        },
        handleSearch(event) {
            if (event && event.target.value) {
                this.timerSearch = setTimeout(() => {
                    this.searchValue = event.target.value
                }, 300)
            } else {
                this.searchValue = ''
            }
        },
        handleClearSearch() {
            this.searchValue = ''
        },
        handleShowOrHideSectionItems(sectionId, isOpen) {
            if (isOpen) {
                this.closedSectionsIds.push(sectionId)
            } else {
                this.closedSectionsIds = this.closedSectionsIds.filter((id) => id !== sectionId)
            }
        },
        closeBoxes(e) {
            if (!this.$refs['stateSelector'].contains(e.target)) {
                this.isSelectorOpen = false
            }

            const permissions = this.$store.getters['issues/getById'](this.$route.params.id)
            if (permissions.config.nRoles && !this.verifyPermissedDelete()) {
                if (this.rolesManagePermissions()) {
                    e.target.value = this.checklist.status
                    this.$popup.alert({
                        message: this.$t('answer.timing.not_has_role_permission', {
                            name: this.user.name,
                            roles: this.rolesManagePermissions()
                        })
                    })
                } else {
                    e.target.value = this.checklist.status
                    this.$popup.alert({
                        message: this.$t('home.permissions_messages.no_manage', {
                            name: this.user.name,
                            type: this.$t('home.types_register.issue')
                        })
                    })
                }

                this.isSelectorOpen = false
                return
            }

            if (!fnCheckConnection() && !this.$store.getters['getOffline']) {
                const self = this
                self.$popup.alert({
                    closable: false,
                    blocking: false,
                    message: self.$t('popup.issues.offline_update'),
                    textSave: self.$t('popup.audits.exit'),
                    callSave: function (response) {
                        self.$popup.close()
                    }
                })
                //disabled selector
                this.isSelectorOpen = false
                return
            }
        },
        updateTitle() {
            if (this.$store.getters['issues/getCustomTitle'](this.checklist.id).title) {
                return (this.cTitle = this.$store.getters['issues/getCustomTitle'](this.checklist.id))
            }
        },
        rolesWithWritePermissions() {
            const permissions = this.$store.getters['issues/getById'](this.$route.params.id)
            log('zzz log', permissions)
            const roles = []
            if (permissions && permissions.config && permissions.config.nRoles && permissions.config.nRoles.length > 0) {
                const idOfRoles = permissions.config.nRoles.map((role) => {
                    if (role.permissions.includes('w')) {
                        return role.roleId
                    }
                })
                Object.values(this.roles).map((role) => {
                    if (idOfRoles.includes(role.id)) {
                        roles.push(role.name)
                    }
                })
            }

            return roles
                .join(', ')
                .toString()
                .replace(/,(?=[^,]*$)/, ' ' + this.$t('answer.or'))
        },
        rolesManagePermissions() {
            const permissions = this.$store.getters['issues/getById'](this.$route.params.id)
            log('zzz log', permissions)
            const roles = []
            if (permissions && permissions.config && permissions.config.nRoles && permissions.config.nRoles.length > 0) {
                const idOfRoles = permissions.config.nRoles.map((role) => {
                    if (role.permissions.includes('rwx')) {
                        return role.roleId
                    }
                })
                Object.values(this.roles).map((role) => {
                    if (idOfRoles.includes(role.id)) {
                        roles.push(role.name)
                    }
                })
            }

            return roles
                .join(', ')
                .toString()
                .replace(/,(?=[^,]*$)/, ' ' + this.$t('answer.or'))
        },
        settingsRegister() {
            const self = this
            this.$popup.itemSettings({
                itemSettings: {
                    noApply: {
                        label: self.$t('popup.item_settings.no_apply'),
                        value: self.showNonApply
                    }
                },
                callSave: (settings) => {
                    const itemSettings = settings.itemSettings
                    self.showNonApply = itemSettings.noApply.value
                    self.$popup.close()
                }
            })
        },
        disableSelector(e) {
            const permissions = this.$store.getters['issues/getById'](this.$route.params.id)
            if (permissions.config.nRoles && !this.verifyPermissedDelete()) {
                if (this.rolesManagePermissions()) {
                    e.target.value = this.checklist.status
                    this.$popup.alert({
                        message: this.$t('answer.timing.not_has_role_permission', {
                            name: this.user.name,
                            roles: this.rolesManagePermissions()
                        })
                    })
                } else {
                    e.target.value = this.checklist.status
                    this.$popup.alert({
                        message: this.$t('home.permissions_messages.no_manage', {
                            name: this.user.name,
                            type: this.$t('home.types_register.issue')
                        })
                    })
                }

                e.target.disabled = true
                return
            }

            if (!fnCheckConnection() && !this.$store.getters['getOffline']) {
                const self = this
                self.$popup.alert({
                    closable: false,
                    blocking: false,
                    message: self.$t('popup.issues.offline_update'),
                    textSave: self.$t('popup.audits.exit'),
                    callSave: function (response) {
                        self.$popup.close()
                    }
                })
                //disabled selector
                e.target.disabled = true
                return
            }
        },
        infoOpened() {
            this.infoIsOpen = !this.infoIsOpen
        },
        getIssueStateClose() {
            // get first issueState with type 3
            return Object.values(this.issueStates).find((issueState) => issueState.type == 3)
        },
        back() {
            if (this.stateChanged) {
                this.$emit('changedState')
            }
            this.$router.push({ name: 'Issues' })
        },
        formatDate(date) {
            return formatDisplayDateFromStore(date, { includeTime: true, emptyValue: '' })
        },
        getString(str) {
            return this.$t(str)
        },
        getStringVariables(str, params) {
            return this.$t(str, params)
        },
        getStringPlural(str, pos) {
            return this.$tc(str, pos)
        },
        getStringVariable(str, pos) {
            return this.$t(str, { s: pos })
        },
        getStringPluralVariable(str, pos, text) {
            return this.$tc(str, pos, { s: text })
        },

        recoverValues() {
            var self = this
            self.$overlay.loading()

            self.$store.dispatch('issues/recoverValues', { check: self.gId }).then(function (response) {
                self.$overlay.hide()
                self.$snackbar.info({ message: self.$t('tooltip.done') })
            })
        },

        currentEmployee() {
            var emp_id = this.$store.getters['loginUser/getLocalEmployee']

            if (emp_id) {
                var emp = this.$store.getters['employee/getEmployee'](emp_id)
            } else {
                var emp = this.$store.getters['loginUser/getLocalLocation']
            }

            return emp
        },

        format(value, type, item) {
            let response = value
            switch (parseInt(type)) {
                case FORMAT.CHECK:
                case FORMAT.YESNO:
                    response = value ? '✅' : '❌'
                    break
                case FORMAT.YESNONC:
                    if (value == 1) response = '✅'
                    else if (value == 2) response = '❌'
                    else response = this.i18n.t('answer.nsnc')
                    break
                case FORMAT.DATE:
                    response = value ? formatDisplayDateFromStore(value, { includeTime: false, emptyValue: '' }) : ''
                    break
                case FORMAT.DATETIME:
                    response = value ? formatDisplayDateFromStore(value, { includeTime: true, emptyValue: '' }) : ''
                    break
                case FORMAT.PHOTO:
                case FORMAT.SIGNATURE:
                    response = value ? '<img src="' + value + '"/>' : value
                    break
                case FORMAT.TEMPERATURE:
                    const units = item.config.units
                    response = `${value}${units}`
                    break
                case FORMAT.EMAIL:
                    response = value ? this.i18n.t('answer.email.send') : this.i18n.t('answer.email.notSend')
                    break
            }
            return response
        },

        toggleInfo() {
            this.collapsedInfo = !this.collapsedInfo
        },

        deleteIssue() {
            if (!this.verifyPermissedDelete()) {
                if (this.rolesManagePermissions()) {
                    this.$popup.alert({
                        message: this.$t('answer.timing.not_has_role_permission', {
                            name: this.user.name,
                            roles: this.rolesManagePermissions()
                        })
                    })
                } else {
                    this.$popup.alert({
                        message: this.$t('home.permissions_messages.no_delete', {
                            name: this.user.name,
                            type: this.$t('home.types_register.issue')
                        })
                    })
                }
                return
            }

            if (!fnCheckConnection()) {
                this.$popup.alert({
                    message: this.$t('popup.issues.offline_remove')
                })
                return
            }

            var self = this
            var employee = self.currentEmployee()

            if (!self.$store.getters['hasAccess'](employee.id, 1)) {
                self.$popup.access({
                    list: self.$store.getters['employee/getLoginUsers'](1),
                    callAfterAccess: function (response) {
                        if (response.status) {
                            self.$popup.close()
                            self.popupDeleteIssue(response.emp_id)
                        }
                    }
                })
            } else {
                self.popupDeleteIssue(employee.id)
            }
        },
        verifyPermissedDelete() {
            if (this.checklist.config && !this.checklist.config.nRoles) {
                return true
            }

            if (this.checklist.config && Array.isArray(this.checklist.config.nRoles) && this.checklist.config.nRoles.length > 0) {
                let permissions = ''
                this.checklist.config.nRoles.forEach((employee) => {
                    if (employee.roleId === this.user.rol) {
                        permissions += employee.permissions
                    }
                })
                return permissions.includes('rwx')
            }
            return false
        },
        popupDeleteIssue(emp_id) {
            var self = this
            var relItem = self.refTask ? self.refTask.task_id : false

            self.$popup.delete({
                message: self.$t('issues.delete_msg', { issue: self.checklist.title }),
                textSave: self.$t('popup.delete.text_save'),
                textCancel: self.$t('popup.delete.text_cancel'),
                callSave: function () {
                    self.$overlay.loading()
                    self.$store.dispatch('issues/delete', { check: self.gId, emp: emp_id, ref_item: relItem }).then(function (response) {
                        if (response) {
                            self.$popup.close()
                            self.$snackbar.success({ duration: 4000, closeable: true, message: self.$t('issues.deleted_msg') })

                            self.$store.dispatch('tasks/updateIssue', { check: self.refTask.check_id, answer: self.refTask.task_id, toDelete: true })

                            self.$router.push({ name: 'Issues', params: {} })
                        }
                        self.$overlay.hide()
                    })
                }
            })
        },
        checkAllMandatory(mounted) {
            // check if current status of checklist is type 3
            if (this.checklist && Object.values(this.issueStates).length > 0 && this.issueStates[this.checklist.status].type == 3) {
                return
            }
            if (this.checklist && this.checklist.items) {
                // check item.type is not is itemsExcluded array
                let mandatoryItems = Object.values(this.checklist.items).filter((item) => item.mandatory && item.is_visible && !this.itemsExcluded.find((it) => it == item.type))
                let completedItems = mandatoryItems.filter((item) => item.complete_date)
                if (mandatoryItems.length == completedItems.length) {
                    var self = this
                    this.allMandatory = true
                    if (!mounted) {
                        self.$popup.confirm({
                            // TODO usuario logueado
                            message: self.$t('issues.popup.mark_as_completed', { name: self.user.name }),
                            textSave: self.$t('issues.popup.confirm'),
                            textCancel: self.$t('issues.popup.cancel'),
                            callSave: () => {
                                // get issueState id with type 3
                                let issueState = Object.values(self.issueStates).filter((state) => state.type == 3)
                                self.$store.dispatch('issues/update', { check: self.gId, status: issueState[0].id })
                                self.$store.dispatch('tasks/updateIssue', {
                                    check: self.refTask.check_id,
                                    answer: self.refTask.task_id,
                                    status: issueState[0].id
                                })
                                self.allMandatory = false
                            }
                        })
                    }
                } else {
                    this.allMandatory = false
                }
            }
        },

        changeState(e) {
            const permissions = this.$store.getters['issues/getById'](this.$route.params.id)
            if (permissions.config.nRoles && !this.verifyPermissedDelete()) {
                if (e.target) {
                    e.target.value = this.checklist.status
                }

                if (this.rolesManagePermissions()) {
                    this.$popup.alert({
                        message: this.$t('answer.timing.not_has_role_permission', {
                            name: this.user.name,
                            roles: this.rolesManagePermissions()
                        })
                    })
                } else {
                    this.$popup.alert({
                        message: this.$t('home.permissions_messages.no_manage', {
                            name: this.user.name,
                            type: this.$t('home.types_register.issue')
                        })
                    })
                }
                return
            }

            if (!fnCheckConnection() && !this.$store.getters['getOffline']) {
                const self = this
                self.$popup.alert({
                    closable: false,
                    blocking: false,
                    message: self.$t('popup.issues.offline_update'),
                    textSave: self.$t('popup.audits.exit'),
                    callSave: function (response) {
                        self.$popup.close()
                    }
                })
                return
            }

            if (typeof this.checklist !== 'undefined') {
                // check if new state is to close issue
                let val = ''
                if (typeof e == 'string') {
                    val = e
                } else {
                    val = e.target.value
                }
                if (this.issueStates[val].type == 3) {
                    // check if all items mandatory are filled
                    var items = Object.values(this.checklist.items)
                    var mandatory = true
                    for (var i = 0; i < items.length; i++) {
                        if (items[i].mandatory && items[i].is_visible && (items[i].value === '' || items[i].value == null) && items[i].type != 8) {
                            mandatory = false
                            let element = document.getElementById(items[i].item_id)

                            if (element) {
                                const exam = element.closest('#exam')
                                const detailBox = element.closest('.detail-box')
                                const hasScrollContainers = Boolean(exam || detailBox)
                                const innerCanScroll = (exam && exam.scrollHeight > exam.clientHeight) || (detailBox && detailBox.scrollHeight > detailBox.clientHeight)
                                if (!hasScrollContainers || innerCanScroll) {
                                    element.scrollIntoView({ behavior: 'smooth', block: 'start' })
                                }
                            }
                            break
                        }
                    }
                    if (!mandatory) {
                        this.$popup.alert({
                            message: this.$t('issues.mandatory_msg')
                        })
                        this.showErrors = true
                        if (typeof e != 'string') {
                            e.target.value = this.checklist.status
                        }
                        val = this.checklist.status
                        return
                    }
                    this.$store.dispatch('issues/update', { check: this.gId, status: val })
                    this.$store.dispatch('tasks/updateIssue', { check: this.refTask.check_id, answer: this.refTask.task_id, status: val })
                    this.allMandatory = false
                    return
                } else {
                    var self = this
                    this.$store.dispatch('issues/update', { check: this.gId, status: val }).then(() => {
                        self.$store.dispatch('tasks/updateIssue', { check: self.refTask.check_id, answer: self.refTask.task_id, status: val }).then(() => {
                            self.checkAllMandatory(true)
                        })
                    })
                }
                this.stateChanged = true
            }
        },
        toSection(id) {
            const section = document.getElementById(id)

            switch (this.$mq) {
                case 'desktop':
                case 'landscape':
                    document.getElementById('detail-content').scrollTo({
                        top: section.offsetTop - 150,
                        behavior: 'smooth'
                    })
                    break
                case 'portrait':
                    document.getElementById('content').scrollTo({
                        top: section.offsetTop - 150,
                        behavior: 'smooth'
                    })
                    break
            }
        },
        loadSensors() {
            var self = this
            self.$store.dispatch('sensor/loadList').then(function () {})
        },
        loadReference(checklist) {
            log(checklist)
            if (checklist != undefined && checklist && checklist.data && checklist.data.ref && checklist.data.ref.type) {
                let self = this
                let refCheck = checklist.data.ref.checklist
                let refTask = checklist.data.ref.item
                log(checklist.data.ref)
                log(this.referenceType(checklist.data.ref.type))

                self.$store
                    .dispatch(this.referenceType(checklist.data.ref.type) + '/loadById', {
                        id: refCheck
                    })
                    .then(function () {
                        var response = self.$store.getters[self.referenceType(checklist.data.ref.type) + '/getById'](refCheck)
                        if (response) {
                            self.loadRef = true
                            var section = false
                            var task_title = ''
                            var task_id = ''
                            var task_value = ''
                            var task_description = ''
                            var task_section = ''
                            if (parseInt(checklist.data.ref.type) == 2) {
                                for (var k in response.sections) {
                                    var sec = response.sections[k]
                                    section = typeof sec.items[refTask] !== 'undefined' ? k : false
                                }

                                if (section) {
                                    task_title = response.sections[section].items[refTask].title
                                    task_id = response.sections[section].items[refTask].item_id
                                    task_value = self.format(response.sections[section].items[refTask].value, response.sections[section].items[refTask].type, false)
                                    task_description = response.sections[section].items[refTask].description
                                    task_section = response.sections[section].name
                                }
                            } else {
                                const item = response.items[refTask]
                                task_title = response.items[refTask].title
                                task_id = response.items[refTask].item_id
                                task_value = self.format(response.items[refTask].value, response.items[refTask].type, item)
                                task_description = response.items[refTask].description

                                const items = Object.values(response.items).sort(function (firstItem, nextItem) {
                                    return firstItem.order - nextItem.order
                                })

                                let indexOfItem = ''
                                items.find((item, index, _) => {
                                    if (item.item_id === response.items[refTask].item_id) {
                                        indexOfItem = index
                                    }
                                })

                                if (indexOfItem != '') {
                                    const allItemsDivided = items.slice(0, indexOfItem)
                                    //task_section = allItemsDivided[allItemsDivided.length - 1].title
                                    task_section = allItemsDivided.reverse().find((item) => item.type == 8)
                                    task_section = task_section ? task_section.title : ''
                                }
                            }

                            const displayValue = task_value && typeof task_value === 'string' && task_value.includes('|') ? task_value.split('|').join(' | ') : task_value

                            self.refTask = {
                                check_id: response.id,
                                check_title: response.title,
                                check_business_date: response.business_date,
                                check_date: formatDisplayDateOnlyFromStore(response.business_date, { emptyValue: '' }),
                                task_title: task_title,
                                task_id: task_id,
                                task_value: displayValue,
                                task_description: task_description ? task_description : '-',
                                task_section: task_section ? task_section : '-'
                            }
                        }
                    })
            } else {
                this.loadRef = false
            }
        },
        goToReference() {
            if (this.checklist && this.checklist.data && this.checklist.data.ref) {
                var type = this.referenceType(this.checklist.data.ref.type)
                var info = this.$store.getters[type + '/getById'](this.checklist.data.ref.checklist)
                log(type, info)

                if (type == 'tasks') {
                    this.$router.push({
                        name: 'ChecklistDetail',
                        params: {
                            id: this.checklist.data.ref.checklist,
                            checkType: 1,
                            toTaskId: this.checklist.data.ref.item,
                            propDate: moment(this.refTask.check_business_date)
                        }
                    })
                } else if (type == 'audit') {
                    this.$router.push({
                        name: 'AuditEdit',
                        params: {
                            id: info.template_id,
                            checkType: 2,
                            toTaskId: this.checklist.data.ref.item,
                            propDate: moment(this.refTask.check_business_date),
                            edit: this.checklist.data.ref.checklist
                        }
                    })
                } else if (type == 'register') {
                    this.$router.push({
                        name: 'RegisterEdit',
                        params: {
                            id: info.template_id,
                            checkType: 3,
                            toTaskId: this.checklist.data.ref.item,
                            propDate: moment(this.refTask.check_business_date),
                            edit: this.checklist.data.ref.checklist
                        }
                    })
                }
            }
        },
        goToSensor() {
            if (this.checklist && this.checklist.data && this.checklist.data.ref && this.checklist.data.ref.sensor) {
                this.$router.push({
                    name: 'SensorDetail',
                    params: {
                        id: this.checklist.data.ref.sensor
                    }
                })
            }
        },
        redirectPath(firstResult) {
            return this.$root.redirectPath(firstResult)
        },

        referenceType(type) {
            switch (parseInt(type)) {
                case 1:
                    return 'tasks'
                case 2:
                    return 'audit'
                case 3:
                    return 'register'
            }
        }
    },
    filters: {
        moment: function (date, format) {
            return date ? moment(date).format(format) : ''
        }
    },
    mounted() {
        let self = this
        if (this.checklist && Object.values(this.issueStates).length > 0) {
            this.checkAllMandatory(true)
        }
        self.$bar.reset()
        self.$bar.hide()
    },
    created() {
        if (localStorage.getItem('showNonApply') != undefined) {
            this.showNonApply = localStorage.getItem('showNonApply') == 'true' ? true : false
        }
    },
    updated() {
        // START LISTENING CLICKS WHEN UBICATION DIV IS OPENED
        if (this.isSelectorOpen) {
            document.addEventListener('click', this.closeBoxes)
        }
        // STOP LISTENING CLICKS WHEN UBICATION DIV IS CLOSED
        else {
            document.removeEventListener('click', this.closeBoxes)
        }
    },
    watch: {
        sensor: function (val) {
            if (val) {
                this.loadSensors()
            }
        },
        showNonApply(newValue, oldValue) {
            if (newValue !== oldValue) {
                localStorage.setItem('showNonApply', newValue)
                this.$store.commit('checklist/setShowNoApply', newValue)
            }
        },
        searchValue(newValue, oldValue) {
            if (newValue !== oldValue && newValue.length > 0 && this.checklist && this.checklist.items) {
                let idsOfSectionsToShow = []
                let searchResult = []

                const allItems = Object.values(this.checklist.items)

                // Normalizar el texto de búsqueda (remover tildes y convertir a minúsculas)
                const normalizedSearchValue = this.normalizeText(this.searchValue)

                for (const item of allItems) {
                    if (Number(item.type) === 8 && !item.section_id) {
                        // Normalizar el título del item
                        const normalizedTitle = this.normalizeText(item.title)

                        if (normalizedTitle.includes(normalizedSearchValue)) {
                            idsOfSectionsToShow.push(item.item_id)
                            searchResult.push(item)
                        }
                    } else if (item.section_id && idsOfSectionsToShow.includes(item.section_id)) {
                        searchResult.push(item)
                    }
                }

                this.searchResult = searchResult
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#content.issues.detail {
    $column-width: 20%;
    $column-max-width: rem(60px);
    $content-width: 100%;

    > .content {
        $top-info: rem(90px);
        $resume-width: rem(150px);
        $detail-text-color: $main-dark;
        $top-info: rem(70px);
        $resume-width: rem(100px);

        --progress-bar-height: 32px;

        @media (min-width: 768px) {
            --progress-bar-height: 52px;
        }

        overflow: hidden !important;
        padding-top: 0;
        padding-bottom: 0 !important;
        width: calc(#{$content-width}) !important;

        .search-bar-container {
            width: 100%;
            padding-right: 8px;
            padding-left: 8px;
            padding-bottom: 16px;

            .search-container {
                .search {
                    font-size: 18px !important;
                    font-family: $text;
                    background-size: 18px !important;
                }

                .search::placeholder {
                    font-size: 18px !important;
                    font-family: $text;
                }
            }
        }

        .sections-navbar {
            // padding-top: 8px;
            height: 52px;
            position: relative;
            top: 0;
            z-index: 10;
        }

        .progress-bar-section {
            // padding-top: 8px;
            height: var(--progress-bar-height);
            position: relative;
            top: 0;
            z-index: 10;
        }

        .detail-box {
            $sidebar-size: rem(40px);
            $collapse-button: rem(40px);
            $content-padding: rem(0px);
            $detail-bg: $default-bg-color;

            --progress-bar-height: 32px;

            @media (min-width: 768px) {
                --progress-bar-height: 52px;
            }

            position: relative;
            padding: 0;
            padding-left: $content-padding;
            padding-bottom: $menu-aux-height;
            width: 100%;
            background-color: $detail-bg;
            height: calc(100% - (var(--progress-bar-height) + 120px));
            overflow: auto;

            &.with-sections {
                // padding-top: $top-info + $sidebar-size;
                padding-bottom: 0px;
            }

            .list-info {
                $action-size: rem(60px);
                @include default-box-shadow();
                @include display-flex();
                @include justify-content(flex-end);
                @include align-items();
                @include flex-direction(row);
                @include flex-wrap(nowrap);
                background-color: shade($default-bg-color, 5%);
                position: fixed;
                z-index: 9;
                top: $alex-app-padding + $menu-top-height + rem(11px) + $top-info;
                width: calc(100% - #{$column-max-width} - #{$menu-tools-min} - #{$content-padding} - #{$scroll-width});
                height: $action-size;

                &.with-sections {
                    top: $alex-app-padding + $menu-top-height + rem(11px) + $top-info + rem(40px);
                }

                .action {
                    @include font-size(xs);
                    font-family: $text-bold;
                    color: #444;
                    text-align: center;
                    display: block;
                    background-color: shade($default-bg-color, 7%);
                    width: $action-size;
                    height: $action-size;
                    padding: ($action-size - rem(20px)) 6px 2px 6px;
                    margin: 0 9px;
                    cursor: pointer;

                    &.delete {
                        @include background($image: img('delete_alert.svg'), $size: 24px, $position: top 9px center);
                    }
                }
            }

            .exam {
                @include border-radius($default-border-radius);
                // background-color: #fff;
                // padding: 12px 0;
                height: 100%;

                display: flex;
                flex-direction: column;
                gap: 16px;

                .note-detail {
                    // margin-top: 20px;
                    padding-top: 16px;
                    width: 100%;
                    padding: 0 0 0 0;
                    position: relative;
                }

                // &:not(.performing) {
                //     // border: 2px solid #eee;
                //     // background-color: #eee;
                //     // filter: grayscale(70%);
                // }
                // &.performing {
                // }

                & > .reference-link {
                    @include display-flex();
                    @include align-items();
                    @include background($color: shade($default-bg-color, 4%), $image: img('alert_primary.svg'), $position: left 20px center, $size: rem(35px));
                    width: 100%;
                    padding: 16px 20px 16px rem(80px);
                    margin: 0 auto 0 auto;

                    .message {
                        @include border-radius(3px);
                        @include font-size(s);
                        color: $main-s40;
                        display: inline-block;
                        padding-right: 12px;
                        overflow: visible;
                        width: calc(100% - #{rem(100px)});
                        max-width: calc(100% - #{rem(40px)} - #{rem(6px)});
                        min-height: rem(40px);
                        height: auto;

                        > span {
                            @include keepFormat();
                            font-family: $text;
                        }

                        > .date {
                            @include font-size(s);
                            text-transform: capitalize;
                        }
                    }

                    .read-more {
                        @include border-radius(3px);
                        @include background($color: $main, $image: img('right_arrow_light.svg'), $position: right 6px center, $size: 20px);
                        @include font-size(s);
                        color: #fff;
                        font-family: $text;
                        padding: 9px 30px 9px 9px;
                        width: rem(100px);
                        display: inline-block;
                        background-color: $main;
                    }
                }

                .get-last-values {
                    text-align: center;

                    .message {
                        @include interaction();
                        @include border-radius($default-border-radius);
                        @include background($color: $main-t80, $image: img('download_primary.svg'), $position: right 12px center, $size: 22px);
                        @include font-size(m);
                        font-family: $text;
                        color: $main-dark;
                        padding: 12px 42px 12px 12px;
                        display: inline-block;

                        @include bgHover($main-t80);
                    }
                }

                .message-container {
                    width: 100%;
                    padding-left: 8px;
                }

                .close-issue {
                    @include display-flex();
                    @include align-items();
                    @include justify-content();
                    @include flex-direction(column);
                    padding-top: 30px;

                    .text {
                        @include font-size(m);
                        text-align: center;
                        font-family: $text;
                        color: $inactive-s60;
                        padding-bottom: 20px;
                    }

                    .state-card {
                        @include display-flex();
                        @include align-items();
                        @include border-radius(4px);
                        background-color: #fff;
                        padding: 13px;
                        margin-bottom: 20px;
                        cursor: pointer;

                        .ball {
                            width: 15px;
                            height: 15px;
                            border-radius: 50%;
                            margin-right: 6px;
                        }

                        .state-name {
                            @include font-size(sm);
                            font-family: $text-bold;
                        }

                        &:hover {
                            @include bgHover(#fff);
                        }
                    }
                }

                .empty-page-content {
                    .content-message {
                        padding: 16px 24px !important;
                        width: fit-content !important;
                    }

                    .description {
                        padding-top: 0px !important;
                        font-size: 18px !important;
                    }
                }
            }
        }

        .resume {
            @include display-inline-flex();
            @include align-items();
            @include justify-content(flex-end);
            float: right;
            width: 100%;
            // height: 55px;
            z-index: 40;

            height: fit-content;
            padding-bottom: 8px;

            .change-state {
                @include background($image: img('recargar.svg'), $size: 20px, $position: center center);
                @include border-radius(4px);
                background-color: $default-sec-color;
                width: 40px;
                height: 40px;
                margin-right: 4px;
                position: relative;
                // left: 50px;
                cursor: pointer;

                &:hover {
                    @include bgHover($default-sec-color);
                }
            }

            .select {
                position: relative;
                height: 40px;
                // width: 200px;
                width: 280px;
                max-width: 80%;
                @include display-flex();
                @include justify-content(flex-end);
                background-color: #fff;
                border-radius: 4px 0 0 4px;
                background: linear-gradient(90deg, rgba(255, 255, 255, 0) 40%, rgba(255, 255, 255, 1) 100%);

                .ball {
                    width: 15px;
                    height: 15px;
                    min-width: 15px;
                    min-height: 15px;
                    border-radius: 50%;
                    margin-right: 8px;
                    // position: absolute;
                    // left: 58px;
                    // top: 13px;
                    z-index: 2;
                    margin: 10px -23px 0 0;
                }

                .state-selected {
                    @include display-flex();
                    @include align-items(center);
                    @include border-radius(4px);
                    @include font-size(m);
                    background-color: #fff !important;
                    height: 40px;
                    cursor: pointer;
                    // A reset of styles, including removing the default dropdown arrow
                    appearance: none;
                    // Additional resets for further consistency
                    border: none;
                    color: $inactive-s80;
                    font-family: $text-bold;
                    padding: unset;
                    margin: unset;
                    padding-right: 6px;
                    padding-left: 30px;
                    // max-width: 280px;
                    white-space: nowrap;
                    background: linear-gradient(90deg, rgba(199, 39, 123, 0) 25%, rgba(255, 255, 255, 1) 25%);
                    @include text-ellipsis();
                    text-align: left;
                    z-index: 999;

                    .state-name {
                        color: $inactive-s80;
                        font-family: $text-bold;
                    }

                    &::before {
                        content: ' ';
                        position: absolute;
                        left: -56px;
                        top: -6px;
                        height: 20px;
                        @include background($image: img('recargar.svg'), $size: 20px, $position: center center);
                        @include border-radius(4px);
                        background-color: $default-sec-color;
                        width: 40px;
                        height: 40px;
                        margin-right: 4px;
                        color: transparent;
                        cursor: pointer;

                        &:hover {
                            @include bgHover($default-sec-color);
                        }
                    }
                }
            }

            .state-container {
                position: relative;
                height: 40px;
                border-radius: 4px 0 0 4px;
                max-width: calc(100% - 40px);

                .current-state {
                    @include display-flex();
                    @include align-items(center);
                    @include border-radius(4px);
                    @include background($image: img('down_caret_dark.svg'), $position: right 6px center, $size: 6px);
                    border: 0.5px solid;
                    padding: 6px;
                    cursor: pointer;
                    max-width: 238px;
                    border: 1px solid $color-neutral-300;
                    height: 40px;
                    background-color: $color-white;

                    .ball {
                        width: 10px;
                        height: 10px;
                        min-width: 10px;
                        min-height: 10px;
                        border-radius: 50%;
                        margin-right: 8px;
                    }

                    .name {
                        @include text-ellipsis();
                        color: $inactive-s80;
                        font-family: $text-bold;
                        padding-right: 10px;
                    }

                    &.isOpen {
                        @include background($image: img('up_caret_dark.svg'), $position: right 6px center, $size: 6px);
                    }
                }

                .state-selector {
                    @include border-radius(3px);
                    top: 5px;
                    position: relative;
                    background-color: #fff;
                    width: 100%;
                    max-width: 238px;
                    box-shadow: 0px 0px 10px 0px rgba(117, 115, 119, 0.3);
                    z-index: 999;
                    padding-bottom: 6px;

                    .state {
                        width: 100%;
                        @include display-flex();
                        @include align-items(center);
                        @include border-radius(2px);
                        padding: 6px;
                        margin-right: 8px;
                        cursor: pointer;

                        .ball {
                            width: 10px;
                            height: 10px;
                            min-width: 10px;
                            min-height: 10px;
                            border-radius: 50%;
                            margin-right: 8px;
                            margin-left: 2px;
                        }

                        .name {
                            // @include font-size(xs);
                            @include text-ellipsis();
                            color: $color-black;
                            max-width: 87%;
                            font-family: $text-bold;
                        }

                        &:hover {
                            @include bgHover(#fff);
                        }

                        &.selected {
                            background-color: #f4f4f4;

                            // @include background($image: img('tick_dark.svg'), $position: right 12px center, $size: 12px);
                            &:hover {
                                background: #f4f4f4;
                                // @include background($image: img('tick_dark.svg'), $position: right 12px center, $size: 12px);
                            }
                        }
                    }
                }
            }

            .toggle-info {
                @include background($image: img('more_vert_aaaaaa.svg'), $size: 22px);
                display: inline-block;
                width: rem(40px);
                height: 100%;

                &.opened {
                    background-image: img('more_vert_primary.svg');
                }
            }
        }

        .top-container {
            background-color: $default-bg-color;
            width: 100%;
            // padding: 12px;
            padding-bottom: 0px;
            height: auto;
            // padding-top: 0px;
            // margin-bottom: 8px;
            padding-bottom: 16px;
            position: relative;
            top: 0;
            z-index: 41;
        }

        &.desktop {
            .top-container {
                background-color: $default-bg-color;
                width: 100%;
                padding-bottom: 0px;
                max-height: 120px;
            }

            // Calcular la altura de todo el contenido top que es fijo para el listado
            .detail-box {
                height: calc(100% - (var(--progress-bar-height) + 50px));

                &.with-sections {
                    height: calc(100% - (var(--progress-bar-height) + 155px));

                    &.opened-info {
                        height: calc(100% - (var(--progress-bar-height) + 205px));
                    }

                    &.with-search-bar {
                        height: calc(100% - (var(--progress-bar-height) + 155px + 61px));
                        // 61px = search bar + padding

                        &.opened-info {
                            height: calc(100% - (var(--progress-bar-height) + 205px + 61px));
                            // 61px = search bar + padding
                        }
                    }
                }

                &.opened-info {
                    height: calc(100% - (var(--progress-bar-height) + 100px));
                }
            }
        }

        &.landscape {
            // Calcular la altura de todo el contenido top que es fijo para el listado
            .detail-box {
                height: calc(100% - (var(--progress-bar-height) + 50px));

                &.with-sections {
                    height: calc(100% - (var(--progress-bar-height) + 155px)) !important;

                    &.opened-info {
                        height: calc(100% - (var(--progress-bar-height) + 205px)) !important;
                    }

                    &.with-search-bar {
                        height: calc(100% - (var(--progress-bar-height) + 155px + 61px));
                        // 61px = search bar + padding

                        &.opened-info {
                            height: calc(100% - (var(--progress-bar-height) + 205px + 61px));
                            // 61px = search bar + padding
                        }
                    }
                }

                &.opened-info {
                    height: calc(100% - (var(--progress-bar-height) + 170px)) !important;
                }
            }
        }
    }

    > .column.left {
        $content-space: 6px;
        width: $column-width !important;
        max-width: $column-max-width !important;
    }
}
</style>

<style lang="scss">
#content.issues.detail.portrait {
    --header-accordion-extra: 0px;
    padding: 0px !important;

    @media (max-width: 600px) {
        --header-accordion-extra: 130px;
    }

    > #detail-content {
        height: 100% !important;
        margin: 0px !important;

        .select {
            .state-selected {
                @include font-size(s);
            }
        }

        .progress-bar-container {
            padding-right: 0px;
            padding-left: 0px;
        }

        .search-bar-container {
            padding-right: 0px;
            padding-left: 0px;
        }

        .detail-box {
            padding-bottom: 0px !important;
            background: transparent;
            height: calc(100% - 105px);
            overflow: hidden;

            &.with-sections {
                height: calc(100% - (145px + var(--progress-bar-height)));

                &.opened-info {
                    height: calc(100% - (195px + var(--header-accordion-extra)));
                }

                &.with-search-bar {
                    height: calc(100% - (145px + var(--progress-bar-height) + 61px));
                    // 61px = search bar + padding

                    &.opened-info {
                        height: calc(100% - (195px + var(--progress-bar-height) + 61px + var(--header-accordion-extra)));
                        // 61px = search bar + padding
                    }
                }
            }

            &.opened-info {
                height: calc(100% - (155px + var(--header-accordion-extra)));
            }

            .exam {
                .get-last-values {
                    .message {
                        @include font-size(xs);
                        line-height: normal;
                    }
                }
            }

            .top-info {
                width: 100%;
                top: 60px;
                left: 0;
                padding: 10px;
                background-color: $default-bg-color;
                height: auto;

                .content {
                    padding: 5px !important;
                    height: auto;
                    width: 100%;
                    max-width: 100%;

                    .item-name {
                        line-height: 1rem;
                        @include font-size(sm, $important: true);
                        height: 25px;
                    }

                    .item-user {
                        position: absolute;

                        .name {
                            @include font-size(xs, $important: true);
                        }
                    }

                    .item-time {
                        @include font-size(xs);
                        line-height: 0.75rem;
                        margin-top: -5px;
                    }
                }

                .sidebar-sections {
                    position: relative;
                    top: 0;
                    background: transparent;

                    .control-overflow {
                        justify-content: flex-start;

                        .item {
                            @include font-size(xs);
                        }
                    }
                }
            }

            .exam {
                height: 100%;
                padding-bottom: 0px;
                overflow: auto;
                position: relative;
                z-index: 1;

                .justify-description,
                .check-available {
                    padding: 8px 20px 8px 50px;
                    background-size: 25px;
                    background-position: left 10px center;

                    .message {
                        @include font-size(xs);
                        line-height: 1rem;
                        width: calc(100% - 100px);
                    }

                    .action {
                        width: 100px;
                        @include font-size(xs);
                        line-height: 0.75rem;
                    }
                }

                .check-available {
                    .message {
                        width: 100%;
                        max-width: 100%;
                    }
                }

                .close-issue {
                    @include display-flex();
                    @include align-items();
                    @include justify-content();
                    @include flex-direction(column);
                    padding-top: 30px;

                    .text {
                        @include font-size(sm);
                        text-align: center;
                        font-family: $text;
                        color: $inactive-s60;
                        padding-bottom: 20px;
                    }

                    .state-card {
                        @include display-flex();
                        @include align-items();
                        @include border-radius(4px);
                        background-color: #fff;
                        padding: 13px;
                        margin-bottom: 20px;
                        cursor: pointer;

                        .ball {
                            width: 15px;
                            height: 15px;
                            border-radius: 50%;
                            margin-right: 6px;
                        }

                        .state-name {
                            @include font-size(sm);
                            font-family: $text-bold;
                        }
                    }
                }
            }

            &.with-sections {
                height: calc(100% - (145px + var(--progress-bar-height)));
                padding-bottom: 0px;

                &.opened-info {
                    height: calc(100% - (195px + var(--progress-bar-height) + var(--header-accordion-extra)));
                }
            }

            &.opened-info {
                height: calc(100% - (155px + var(--progress-bar-height) + var(--header-accordion-extra)));
            }
        }

        .resume {
            @include display-inline-flex();
            @include align-items();
            @include justify-content(flex-end);
            float: right;
            width: 100%;
            // height: 55px;
            height: 40px;
            z-index: 40;
            position: relative;
            padding-right: 0px;

            .count {
                @include font-size(sm);
                float: right;
            }

            .current-state,
            .state-selector {
                font-size: 16px;
            }
        }

        .top-container {
            padding: 0px;
        }
    }
}
</style>
